import * as types from 'misc/types';
import * as actions from 'misc/actions';

const government_status = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_GOVERNMENT_CONNECT_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_GOVERNMENT_CONNECT_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_GOVERNMENT_CONNECT_GET.FAILURE:
            return actions.error(state, action.error);

        case types.SAGA_GOVERNMENT_CONNECT_POST.REQUEST:
            return actions.load(state);
        case types.SAGA_GOVERNMENT_CONNECT_POST.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_GOVERNMENT_CONNECT_POST.FAILURE:
            return actions.error(state, action.error);

        case types.SAGA_GOVERNMENT_CONNECT_DELETE.REQUEST:
            return actions.load(state);
        case types.SAGA_GOVERNMENT_CONNECT_DELETE.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_GOVERNMENT_CONNECT_DELETE.FAILURE:
            return actions.error(state, action.error);

        default:
            return state;
    }
};

export default government_status;



// WEBPACK FOOTER //
// ./src/reducers/government_status.js